/*
 * Copyright (C) 2016 Spanning Cloud Apps.  All rights reserved.
 */
import './selectDestinationView.tpl.html';

angular
  .module('bulkExport.selectDestinationView', ['shared.radioButton'])
  /**
   * Controller for the bulkRestore.selectview template.
   */
  .controller('BulkExportSelectDestinationViewCtrl', [
    '$scope',
    '$state',
    '$filter',
    '$window',
    'WizardService',
    'BulkRestoreObjectListType',
    'BULK_RESTORE_TYPES',
    'BULK_RESTORE_DEST_TYPES',
    function (
      $scope,
      $state,
      $filter,
      $window,
      WizardService,
      BulkRestoreObjectListType,
      BULK_RESTORE_TYPES,
      BULK_RESTORE_DEST_TYPES
    ) {
      if (!$state.params.bulkRestoreData) {
        throw new Error('bulkRestoreData is required');
      }

      var i18n = $filter('i18n');

      // Register our page with the wizard service
      var page = WizardService.getCurrentPage();
      page.setHeaderText(i18n('SELECT_METHOD'));
      page.setStateParams($state.params);
      page.setTouched(function () {
        return $scope.touched;
      });
      page.setValid(isValid);

      $scope.bulkRestoreData = $state.params.bulkRestoreData;
      $scope.bulkRestoreTypes = BULK_RESTORE_TYPES;
      $scope.bulkRestoreDestTypes = BULK_RESTORE_DEST_TYPES;
      $scope.BulkRestoreObjectListType = BulkRestoreObjectListType;
      $scope.inTheFollowingSteps = i18n('IN_FOLLOWING_STEPS_EXPORT');

      if ($scope.bulkRestoreData.isCrossOrgRestore()) {
        $scope.differentDestination = $scope.bulkRestoreData.getDestOrgInfo();
      }

      recordTypeSelected($scope.bulkRestoreTypes.OBJECT);

      // Default to search
      objectListTypeSelected($scope.bulkRestoreData.getManualObjectListType() || BulkRestoreObjectListType.BROWSE);

      // We'll update this as the user interacts with the controls
      $scope.touched = !!$scope.bulkRestoreData.getRecordType();

      $scope.$watch(
        function () {
          // Don't change the name of this scope variable. There is magic in
          // services/src/templates/htmlResponse/success.hbs that sets this property.
          return $scope.differentDestination;
        },
        function (newVal, oldVal) {
          if (newVal && newVal !== oldVal) {
            $scope.bulkRestoreData.setDestOrgInfo($scope.differentDestination);
          }
        }
      );

      /**
       * Utility method to update selected record type setting.
       *
       * @param {Number} type - The record setting type.
       */
      function recordTypeSelected(type) {
        $scope.bulkRestoreData.setRecordType(type);

        // reset $scope.userCompletedSteps every time
        // Metadata restore doesn't require user steps
        $scope.userCompletedSteps = $scope.bulkRestoreData.isMetadataRestore();
        updateWizardSteps();

        $scope.touched = true;

        // reset backupBatchId every time
        $scope.bulkRestoreData.resetBackupBatchId();
      }
      $scope.recordTypeSelected = recordTypeSelected;

      /**
       * Utility method to update selected restore destination type setting.
       *
       * @param {Number} type - The restore destination type.
       */
      $scope.destinationTypeSelected = function (type) {
        $scope.bulkRestoreData.setDestType(type);

        // reset $scope.userCompletedSteps every time
        // Metadata restore doesn't require user steps
        $scope.userCompletedSteps = $scope.bulkRestoreData.isMetadataRestore();

        $scope.bulkRestoreData.setDestOrgInfo(
          $scope.hasDifferentDestinationSelected() ? $scope.differentDestination : null
        );

        // Cross-org restore uses upload
        if (type === BULK_RESTORE_DEST_TYPES.CROSS_ORG) {
          $scope.bulkRestoreData.setManualObjectListType(BulkRestoreObjectListType.UPLOAD);
        }

        updateWizardSteps();

        $scope.touched = true;
      };

      /**
       * Called when the user selects an object list type (object selection method)
       *
       * @param {string} type - the selected type
       */
      function objectListTypeSelected(type) {
        $scope.bulkRestoreData.setManualObjectListType(type);
        updateWizardSteps();
        $scope.touched = true;
      }
      $scope.objectListTypeSelected = objectListTypeSelected;

      /**
       * Updates the steps in the wizard based on the current selections.
       */
      function updateWizardSteps() {
        var stepKeys;

        if ($scope.bulkRestoreData.isManualObjectSearch() || $scope.bulkRestoreData.isManualObjectBrowse()) {
          stepKeys = ['SELECT_METHOD', 'SELECT_ITEMS', 'EXPORT_SETTINGS', 'CONFIRM_EXPORT'];
        } else if ($scope.bulkRestoreData.isManualObjectUpload()) {
          stepKeys = ['SELECT_METHOD', 'PREPARE_CSV'];
        } else {
          // null in the last position means we don't yet know the remaining steps
          stepKeys = ['SELECT_METHOD', null];
        }

        WizardService.setStepKeys(stepKeys);
      }
      $scope.updateWizardSteps = updateWizardSteps;

      /**
       * Utility method to check if selected destination is valid.
       */
      $scope.hasDifferentDestinationSelected = function () {
        return !!$scope.differentDestination && !_.isEmpty($scope.differentDestination);
      };

      /**
       * Utility method to update userCompletedSteps
       */
      $scope.toggleUserCompletedSteps = function () {
        $scope.userCompletedSteps = !$scope.userCompletedSteps;
        $scope.touched = true;
      };

      /**
       * Utility method to trim the suffix off the destination org in a cross org restore.
       *
       * @params {string} sfOrgId - The sfOrgId to trim
       * @returns {string} - the trimmed sfId string
       */
      $scope.trimOrgSuffix = function (sfOrgId) {
        return sfOrgId.indexOf('-') > -1 ? sfOrgId.split('-')[0] : sfOrgId;
      };

      /**
       * Function to open modal to add new org to restore to.
       * @param {boolean} [isSandBox=false] - Flag to get correct url login for sand box orgs
       */
      $scope.addDestinationOrg = function (isSandBox) {
        var height = 500,
          width = 650,
          x = $window.screen.width / 2 - width / 2,
          y = $window.screen.height / 2 - height / 2;

        isSandBox = isSandBox || false;

        if ($scope.bulkRestoreData.isCrossOrgRestore()) {
          $window.open(
            '/login/crossorg?isSandBox=' + isSandBox,
            'SBSF-Salesforce-Oauth',
            'menubar=no,location=no,resizable=yes,scrollbars=yes,status=no,height=' +
              height +
              ',width=' +
              width +
              ',left=' +
              x +
              ',top=' +
              y
          );
        }
      };

      /**
       * Determines whether the settings on the page are valid (i.e. Next is allowed in the wizard)
       *
       * @returns {boolean} true if the settings are valid, false otherwise.
       */
      function isValid() {
        // Record type and destination type must be selected
        if (!$scope.bulkRestoreData.getRecordType() || !$scope.bulkRestoreData.getDestType()) {
          return false;
        }

        // For object restore, object list type must be selected
        if ($scope.bulkRestoreData.isObjectRestore() && !$scope.bulkRestoreData.getManualObjectListType()) {
          return false;
        }

        // Cross-org requires additional checking. Other destination types do not.
        if ($scope.bulkRestoreData.isSameOrgRestore()) {
          return true;
        }

        // These are the requirements for cross-org restore
        return $scope.hasDifferentDestinationSelected() && $scope.userCompletedSteps;
      }
    }
  ]);
